import { Button, Form, Modal, notification } from 'antd';
import styled from 'styled-components';
import PrimaryButton from '../UI/PrimaryButton';
import CustomInput from '../UI/CustomInput';
import CustomSelect from '../UI/CustomSelect';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { Asset } from 'metaverse-js/lib/proto/model/asset';
import CustomCheckbox from '../UI/CustomCheckbox';
import BigNumber from 'bignumber.js';

const StyledModal = styled(Modal)`
	.ant-modal-content {
		background: #070c1e;
		border-radius: 8px;
		padding: 0;
		color: #737283;
		width: 700px;
	}
	.ant-modal-header {
		background: #091229;
		height: 60px;
		padding: 20px 30px;
	}
	.ant-modal-title {
		color: #d1d4dc;
	}
	.ant-modal-body {
		padding: 10px 30px;
	}
	.ant-modal-close {
		color: #fff;
	}
`;
const Footer = styled.div`
	display: flex;
	gap: 30px;
	align-items: center;
	margin-top: 30px;
	justify-content: center;
`;

const Row = styled.div`
	display: flex;
	align-items: center;
	gap: 30px;
`;
const Label = styled.div`
	font-weight: 400;
	font-size: 16px;
	line-height: 16px;
	color: #737283;
	width: 150px;
`;

const FormContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 30px;
	padding-bottom: 30px;
`;
interface Props {
	open: boolean;
	onClose: () => void;
	refresh: () => void;
	currencyDetail: Asset | undefined;
}

const UpdateCurrencyModal: React.FC<Props> = ({
	open,
	onClose,
	refresh,
	currencyDetail,
}: Props) => {
	const [form] = Form.useForm();
	const [api, contextHolder] = notification.useNotification();
	const metaverseJs = useSelector(
		(state: RootState) => state.system.metaverseJs
	);
	const onFinish = async (values: any) => {
		if (!metaverseJs) return;
		try {
			const body: Asset = {
				...currencyDetail,
				...values,
				depositStatus: values.depositStatus ? 'ENABLED' : 'DISABLED',
				withdrawStatus: values.withdrawStatus ? 'ENABLED' : 'DISABLED',
				flatFee: new BigNumber(values.flatFee).toNumber(),
				transactionFeePercent: new BigNumber(
					values.transactionFeePercent
				).toNumber(),
				minPerOneOrder: new BigNumber(values.minPerOneOrder).toNumber(),
				maxPerOneDay: new BigNumber(values.maxPerOneDay).toNumber(),
				thresholdToReview: new BigNumber(values.thresholdToReview).toNumber(),
			};
			const res = await metaverseJs.updateAsset(currencyDetail?.id, body);
			if (res.id) {
				api.success({
					message: 'Update config successfully',
				});
				handleClose();
				refresh();
			}
		} catch (error: any) {
			api.error({
				message: error?.response?.data?.message || 'Something went wrong',
			});
		}
	};

	useEffect(() => {
		if (open) {
			form.setFieldsValue({
				chain: currencyDetail?.chain,
				symbol: currencyDetail?.symbol,
				depositStatus: currencyDetail?.depositStatus === 'ENABLED',
				withdrawStatus: currencyDetail?.withdrawStatus === 'ENABLED',
				minPerOneOrder: currencyDetail?.minPerOneOrder,
				maxPerOneDay: currencyDetail?.maxPerOneDay,
				thresholdToReview: currencyDetail?.thresholdToReview,
				flatFee: currencyDetail?.flatFee,
				transactionFeePercent: currencyDetail?.transactionFeePercent,
			});
		}
	}, [currencyDetail, open]);

	const handleClose = () => {
		onClose();
		form.resetFields();
	};

	return (
		<StyledModal
			title="Update currency"
			open={open}
			onCancel={handleClose}
			footer={null}
			centered
		>
			{contextHolder}
			<Form onFinish={onFinish} form={form}>
				<FormContent>
					<Row>
						<Label>Select Enable</Label>
						<Row style={{ flex: 1 }}>
							<CustomCheckbox
								style={{
									marginBottom: 0,
								}}
								name={'depositStatus'}
								label="Deposit"
							/>
							<CustomCheckbox
								style={{
									marginBottom: 0,
								}}
								name={'withdrawStatus'}
								label="Withdraw"
							/>
						</Row>
					</Row>
					<Row>
						<Label>Currency</Label>
						<Row style={{ flex: 1 }}>
							<CustomSelect
								style={{
									width: '100%',
									margin: 0,
								}}
								name={'symbol'}
								label=""
								options={[]}
								selectProps={{
									disabled: true,
									style: {
										width: '100%',
									},
								}}
							/>
						</Row>
					</Row>
					<Row>
						<Label>Network</Label>
						<Row style={{ flex: 1 }}>
							<CustomSelect
								style={{
									width: '100%',
									margin: 0,
								}}
								name={'chain'}
								label=""
								options={[]}
								selectProps={{
									disabled: true,
									style: {
										width: '100%',
									},
								}}
							/>
						</Row>
					</Row>
					<Row>
						<Label>Withdraw amount</Label>
						<Row style={{ flex: 1 }}>
							<CustomInput
								labelCol={{ span: 24 }}
								label="Min per one order"
								name={'minPerOneOrder'}
								inputProps={{
									type: 'number',
								}}
							/>
							<CustomInput
								labelCol={{ span: 24 }}
								label="Threshod to review"
								name={'thresholdToReview'}
								inputProps={{
									type: 'number',
								}}
							/>

							<CustomInput
								labelCol={{ span: 24 }}
								label="Max per one day"
								name={'maxPerOneDay'}
								inputProps={{
									type: 'number',
								}}
							/>
						</Row>
					</Row>
					<Row>
						<Label>Platform fee (*)</Label>
						<div style={{ flexDirection: 'column', display: 'flex', flex: 1 }}>
							<Row style={{ flex: 1 }}>
								<CustomInput
									labelCol={{ span: 24 }}
									name={'flatFee'}
									label="Flat fee"
									inputProps={{
										type: 'number',
									}}
								/>
								<CustomInput
									labelCol={{ span: 24 }}
									name={'transactionFeePercent'}
									label="Transaction fee pecent (%)"
									inputProps={{
										type: 'number',
									}}
								/>
							</Row>
							<div style={{ color: '#ffffff40', width: '100%' }}>
								Platform fee = Flat fee + Transaction fee = Flat fee + (Withdraw
								amount * Transaction fee pecent)
							</div>
						</div>
					</Row>

					<Footer>
						<Button
							type="primary"
							ghost
							style={{
								width: '40%',
								height: 46,
							}}
							onClick={handleClose}
						>
							Cancel
						</Button>
						<PrimaryButton
							style={{
								width: '40%',
							}}
							htmlType="submit"
						>
							Save
						</PrimaryButton>
					</Footer>
				</FormContent>
			</Form>
		</StyledModal>
	);
};

export default UpdateCurrencyModal;
